import React from 'react';

const Luxembourg = (props) => (
  <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3127_46321)">
      <rect width="28" height="20" rx="3" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M0 13.3335H28V20.0002H0V13.3335Z" fill="#3ECBF8" />
      <path fillRule="evenodd" clipRule="evenodd" d="M0 0H28V6.66667H0V0Z" fill="#F93939" />
    </g>
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" stroke="#AEAEAE" strokeWidth="0.5" />
    <defs>
      <clipPath id="clip0_3127_46321">
        <rect width="28" height="20" rx="3" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Luxembourg;
